<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :active-tab="activeTab"
    :action-type="actionType"
    :saveIsDisabled="!required.filled"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <template v-for="field in visibleTabs[activeTab].fields">
          <input-field
            v-if="
              field.var_name === 'bl_type' &&
              field.select_list_name === 'list_blockage_obstruction_type'
            "
            :key="visibleTabs[activeTab].label + field.label + field.order"
            :value="getValueInObject(field.var_name, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            inputType="other"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :hide="field.hide"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
          >
            <div>
              <treeselect
                :value="objectData.bl_type"
                :options="blockageTypeOptions"
                @input="setValueInObject(field.var_name, $event)"
                :normalizer="blockageTypeOptionsNormalizer"
                :disabled="
                  readOnly ||
                    !userCanEditTabContent(visibleTabs[activeTab]) ||
                    field.disable
                "
                class="form-input-select"
                disableFuzzyMatching
              />
            </div>
          </input-field>
          <input-field
            v-else
            :key="visibleTabs[activeTab].label + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            @input="setValueInObject(field.var_name, $event, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            :inputType="field.input_type"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :selectOptions="field.select_list_name"
            :radioOptions="field.radio_options"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
            :hide="field.hide"
            :checkboxOptions="field.checkbox_options"
            :object-data="objectData"
            :labelIsLocked="objectData.bl_label_locked"
            :user-can-unlock-label="!userHasFibercloudPermission(form.permission + '_manage_label')"
            @toggle-label-lock="changeLabelMode"
            @updateCheckboxValue="updateCheckboxValue($event)"
            @removePhoto="addToPhotosToRemove($event)"
          />
        </template>
      </div>

      <div
        v-show="visibleTabs[activeTab].code === 'blockage_specific_fields'"
        class="form tab-content"
      >
        <input-field
          v-for="field in obstructionTypeSpecificFields"
          :key="field.var_name"
          :value="getValueInObject(field.var_name, field.input_type, 'blockage_specific_fields')"
          @input="setValueInObject(field.var_name, $event, 'blockage_specific_fields')"
          :label="field.label"
          :variable-name="field.var_name"
          :input-type="field.input_type"
          size="small"
          :required="field.required"
          :required-filled="required.filled"
          :radioOptions="field.radio_options"
          :checkboxOptions="field.checkbox_options"
          :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
          :formDisabled="readOnly"
          :objectData="objectData"
          @updateCheckboxValue="updateCheckboxValue($event, 'blockage_specific_fields')"
        />
      </div>
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import InputField from "../_Molecules/InputField";
import { listsMixin } from "@/mixins/listsMixin";
import { bus } from "@/main.js";
import { mapActions } from 'vuex';

export default {
  name: "BlockageForm",

  components: {
    InputField,
    DynamicObjectFormStructure,
  },

  mixins: [dynamicObjectFormsMixin, listsMixin, checkPermissionsMixin],

  props: {
    linkObjectToPathway: {
      type: Object
    }
  },

  data() {
    return {
      obstructionTypeSpecificFields: [],
    }
  },

  computed: {
    blockageTypeOptions() {
      let allObstructionTypes =  this.$store.getters.getListOfOptionsByListName(
        "list_blockage_obstruction_type",
        [this.objectData.bl_type],
        true
      );

      let layer = this.actionType === "edit" || this.actionType === "view"
        ? this.objectData.layer
        : this.$attrs.blockageObject.nodeObject === null
          ? this.$attrs.blockageObject.nodeObject
          : this.$attrs.blockageObject.nodeObject.object_type;

      switch(layer) {
        case "fc_pole":
          return allObstructionTypes.filter(type => ["TC", "TMP", "PR", "NP", "D", "DP"].includes(type.code))
        case "fc_manhole":
          return allObstructionTypes.filter(type => ["DS", "GS", "TMC", "FCR", "NC"].includes(type.code))
        case "fc_pathway":
          return allObstructionTypes.filter(type => ["B", "TMD"].includes(type.code))
        case null:
          return allObstructionTypes.filter(type => ["ME"].includes(type.code))
      }
    },
  },

  watch: {
    "objectData.bl_type"(value) {
      this.clearObstructionTypeRequiredFields();
      this.$nextTick(() => {
        if (!!value) {
          this.getObstructionTypeFields(value);
        } else {
          this.objectData.specific_fields = {};
          this.obstructionTypeSpecificFields = [];
        }
      })
    },

    obstructionTypeSpecificFields: {
      handler:function (value) {
        value.forEach(field => {
          if (field.input_type === "checkbox" && typeof this.objectData.specific_fields[field.var_name] === "string") {
            this.setValueInObject(field.var_name, this.objectData.specific_fields[field.var_name] === "true", "blockage_specific_fields")
          }
        });
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(["fetchObstructionTypeFields"]),

    createObject() {
      this.createDataToSend();

      this.CREATE_OBJECTS({
        endpoint: this.form.endpoint,
        data: [this.dataToSend]
      })
        .then(technicalPointData => {
          if (this.linkObjectToPathway.split) {
            bus.$emit("reset-pathway-and-split-data");
          }

          this.objectData.tp_label = this.incrementLabelSequential(
            this.objectData.tp_label
          );

          this.finishObjectCreation();
          if (this.$attrs.nextForm) {
            this.$emit("open-next-form", {
              createdTechPointData: technicalPointData.data.data[0],
              techPointGeom: this.dataToSend.node.text_geom
            });
          }
        })
        .catch(error => {
          this.$toasted.global.toast_error(error.response.data.data);
          this.loadingSave = false;
        });
    },

    createDataToSend() {
      this.dataToSend = {
        node: { text_geom: this.wkt, projection: 3857 },
        status: this.objectData.tp_status,
        progress: this.objectData.tp_progress,
        // physical_type: "V",
        // technical_point_type: "V",
        // logical_type: "T" //TODO - Remove when removed required from back-end
      };

      if (!!this.$attrs.blockageObject.technical_point_id) {
        this.dataToSend.technical_point_id = this.$attrs.blockageObject.technical_point_id
      }
      if (!!this.$attrs.blockageObject.pathway_id) {
        this.dataToSend.pathway_id = this.$attrs.blockageObject.pathway_id
      }

      if (this.linkObjectToPathway.split) {
        this.dataToSend.node.delete_pathways_association = "false";
        this.dataToSend.node.pathway = this.linkObjectToPathway.pathway;
      }
      this.placeObjectDataInDataToSend();
    },

    blockageTypeOptionsNormalizer(node) {
      return {
        id: node.code,
        label: node.client_label ? node.client_label : node.libelle
      };
    },

    async getObstructionTypeFields(obstructionType) {
      try {
        let obstructionTypeFields = await this.fetchObstructionTypeFields({
          obstructionType: obstructionType,
          includes: "radioOptions,checkboxOptions"
        });

        obstructionTypeFields.forEach(field => {
          Object.keys(field).forEach(key => {
            if (key.includes("bf_")) {
              let newKey = key.replace("bf_", "");
              field[newKey] = field[key];
              delete field[key];
            }

            if (key === "checkbox_options") {
              field[key].forEach(option => {
                Object.keys(option).forEach(key => {
                  let newKey = key.replace("bco_", "");
                  option[newKey] = option[key];
                  delete option[key];
                });
              })
            }

            if (key === "radio_options") {
              field[key].forEach(option => {
                Object.keys(option).forEach(key => {
                  let newKey = key.replace("bro_", "");
                  option[newKey] = option[key];
                  delete option[key];
                });
              })
            }
          });


          if (field.required) {
            this.registerRequiredField(field);
            this.$nextTick(() => { this.checkRequiredFieldsAreFilled(); });
          }
        })

        this.obstructionTypeSpecificFields = obstructionTypeFields;

      } catch (e) {
        console.error(e);
      }
    },

    clearObstructionTypeRequiredFields() {
      for (let i = 0; i < this.required.fields.length; i++) {
        const field = this.required.fields[i];
        if (!!field.blockage_type) {
          this.required.fields.splice(i, 1);
          i--;
        }
      }
      this.checkRequiredFieldsAreFilled();
    },
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/BlockageForm.vue